import customHeaders, { getSpace } from '../../../common/headers';
import { useState, useEffect, useRef } from 'react';
import { DropDownSelector, ButtonBasic, ButtonClose } from '@lk-gtcom/ecomlab-components';
import { StepItem } from '../../../components/StepItem/StepItem';
import { TitlePage } from '../../../components/TitlePage/TitlePage';
import useGeneralStore from '../../../store/general';
import './ModalCreateAutocompleteTemplatesAi.scss';
import { StepPoints } from '../../../components/StepPoints/StepPoints';
import { useResponseHandler } from '../../../common/auth';
import { ModalAddTaskExit } from './ModalAddTaskExit/ModalAddTaskExit';
import { MoonLoader } from 'react-spinners';
import Cookies from 'universal-cookie';
import { usePushNotifications } from '../../../common/pushNotification';

const ModalCreateAutocompleteTemplatesAi = ({
  setIsModal,
  currentСampaign,
  setCurrentСampaign,
  fetchDeleteTask
}) => {

  // Рефы
  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);

  const [loadingUpload1, setLoadingUpload1] = useState(false)
  const [loadingUpload2, setLoadingUpload2] = useState(false)

  // Обработка ошибок
  const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications();
  const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();

  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const cookies = new Cookies();
  const token = cookies.get('auth');

  const [currentStep, setCurrentStep] = useState(1)

  const [isSave, setIsSave] = useState(currentСampaign?.id)
  const [isDisabledStart, setIsDisabledStart] = useState(false)
  const [isDisabledBarcode, setIsDisabledBarcode] = useState(false)
  const [isDisabledTemplate, setIsDisabledTemplate] = useState(false)

  const [fileTemplate, setFileTemplate] = useState([])
  const [fileBarcode, setFileBarcode] = useState([])

  // Фильтры
  const [categoryData2, setCategoryData2] = useState([]);
  const [selectedCategory2, setSelectedCategory2] = useState({});
  const [categoryPage2, setCategoryPage2] = useState(1);
  const [categoryQuery2, setCategoryQuery2] = useState('');

  // Modal 
  const [isModalLog, setIsModalLog] = useState(false)
  const [isModalExit, setIsModalExit] = useState(false)

  // Loader
  const [isLoadTemplate, setIsLoadTemplate] = useState(false)
  const [isLoadBarcode, setIsLoadBarcode] = useState(false)

  const abortControllerRef = useRef(null);

  // Очищаем контроллер при размонтировании
  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  // Создание задачи
  const fetchСreateСampaign = () => {
    if (selectedCategory2?.value) {
      let url = `https://apps0.ecomru.ru:4460/api/v1/task/create`

      const body = JSON.stringify({
        category_id: selectedCategory2?.value
      })

      fetch(url, { body, method: 'POST', headers })
        .then(handleTableResponse)
        .then((json) => {
          setCurrentStep(2)
          setCurrentСampaign(json?.new_task_id)
          setIsSave(true)
        })
        .catch(handleRequestError)
        .finally(() => { });
    }
  };

  // Получение категорий
  const fetchGetCategory = (limit = 50) => {
    let url = `https://apps0.ecomru.ru:4460/api/v1/categories`

    const body = JSON.stringify({
      pagination: {
        page: categoryPage2,
        limit
      },
      search_param: categoryQuery2
    })

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then((json) => {
        if (json) {
          const data = json.map(({ category_id, category_name }) => ({ label: category_name, value: category_id }))
          if (categoryPage2 > 1) {
            setCategoryData2((prev) => [...prev, ...data]);
          } else {
            setCategoryData2(data);
          }
        }
      })
      .catch(handleRequestError);
  }

  // Загрузить просто шаблон
  const onUploadFile = (link) => {

    setLoadingUpload1(true)
    addWarningPush('Дождитесь окончания загрузки, после завершения процесса  появится уведомление')
    const url = `https://apps0.ecomru.ru:4460/api/v1/template/upload`;

    const body = JSON.stringify({
      task_id: currentСampaign,
      url: link
    })

    fetch(url, {
      method: 'POST',
      headers,
      body,
    })
      .then(async (res) => {
        const data = await res.json(); // сначала парсим ответ
        if (res.status === 201) {
          setIsDisabledTemplate(true)
          setCurrentStep(3)
          return data;
        }

        if (!res.ok) {
          const errorMessage = data.detail;
          addErrorPush(`Ошибка загрузки: ${errorMessage}`);
          throw new Error(`Upload failed: ${res.statusText}`);
        }
        return res.json();
      })
      .then((data) => {
        addSuccessPush('Файл успешно загружен')
        if (fileInputRef1.current) fileInputRef1.current.value = ''
      })
      .catch((err) => {
        console.error(err);
        if (fileInputRef1.current) fileInputRef1.current.value = ''
      })
      .finally(() => {
        setIsLoadTemplate(false)
        setLoadingUpload1(false)
      });
  };

  // Загрузить баркоды
  const onUploadFileBarcode = (link) => {

    setLoadingUpload2(true)
    addWarningPush('Дождитесь окончания загрузки, после завершения процесса  появится уведомление')
    const url = `https://apps0.ecomru.ru:4460/api/v1/upload-barcode`;

    const body = JSON.stringify({
      task_id: currentСampaign,
      url: link
    })

    fetch(url, {
      headers,
      method: 'POST',
      body,
    })
      .then(async (res) => {
        const data = await res.json(); // сначала парсим ответ
        if (res.ok) {
          setCurrentStep(4)
          setIsDisabledBarcode(true)
          return data;
        }

        if (!res.ok) {
          const errorMessage = data.detail;
          addErrorPush(`Ошибка загрузки: ${errorMessage}`);
          throw new Error(`Upload failed: ${res.statusText}`);
        }
        return res.json();
      })
      .then((data) => {
        addSuccessPush('Файл успешно загружен')
        if (fileInputRef2.current) fileInputRef2.current.value = ''
      })
      .catch((err) => {
        console.error(err);
        if (fileInputRef2.current) fileInputRef2.current.value = ''
      })
      .finally(() => {
        setIsLoadBarcode(false)
        setLoadingUpload2(false)
      });
  };

  // Запустить
  const fetchStartTask = () => {
    if (selectedCategory2?.value) {
      let url = `https://apps0.ecomru.ru:4460/api/v1/start-task`

      const body = JSON.stringify({
        task_id: currentСampaign
      })

      fetch(url, { body, method: 'POST', headers })
        .then(async (res) => {
          if (res.ok) {
            return res.json();
          } else {
            const err = await res.json();
            throw Error(JSON.stringify(err));
          }
        })
        .then((json) => {
          setIsDisabledStart(true)
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => { });
    }
  };

  // Загрузить файл
  const fetchPostFile = (file, set, template = false) => {

    if (template) {
      setIsLoadTemplate(true)
    } else {
      setIsLoadBarcode(true)
    }

    // Отменяем предыдущий запрос, если он есть
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Создаем новый контроллер для текущего запроса
    abortControllerRef.current = new AbortController();

    const fd = new FormData();
    fd.append('file', file);

    const url = `https://file.ecomru.ru:4453/api/v1/file/upload`;

    const requestHeaders = {
      'space': selectedSpace?.value,
      'Accept': 'application/json',
      'access': 'public',
      'Cache-control': 'no-cache',
      'Authorization': `Bearer ${token}`
    };

    fetch(url, {
      method: 'POST',
      body: fd,
      headers: requestHeaders,
      signal: abortControllerRef.current.signal
    })
      .then(res => {
        if (handleStatusCode(res.status)) {
          return;
        }
        if (res.ok) {
          return res.json()
        } else {
          console.log('err')
          throw new Error(`Server responded with ${res.status}`)
        }
      })
      .then(json => {
        set(json)
      })
      .catch(err => {
        setIsLoadTemplate(false)
        setIsLoadBarcode(false)
        alert(`Ошибка загрузки`);
        console.error('Upload failed:', err)
      })
  }

  useEffect(() => {
    if (fileBarcode?.url) {
      onUploadFileBarcode(fileBarcode?.url)
    }
  }, [fileBarcode]);

  useEffect(() => {
    if (fileTemplate?.url) {
      onUploadFile(fileTemplate?.url)
    }
  }, [fileTemplate]);

  useEffect(() => {
    fetchGetCategory()
  }, []);

  useEffect(() => {
    fetchGetCategory()
  }, [categoryPage2, categoryQuery2]);

  const handleFile = async (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      await fetchPostFile(selectedFile, setFileTemplate, true);
    }
  };

  const handleFileBarcode = async (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      await fetchPostFile(selectedFile, setFileBarcode);
    }
  };

  const onCloseModal = () => {
    setIsModal(false)
    setCurrentСampaign(null)
  }

  const isDisabled = !selectedCategory2?.value

  const handleDownload = async (e, new_filename, url) => {
    e.preventDefault()
    e.stopPropagation();
    const response = await fetch(url);
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = new_filename; // Желаемое имя
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  };

  return (
    <>
      {isModalExit && <ModalAddTaskExit
        id={currentСampaign}
        onClose={onCloseModal}
        setIsModal={setIsModalExit}
        fetchDeleteTask={fetchDeleteTask}
      />}

      <div
        className="blackout blackout-modal"
        onClick={(e) => {
          let el = e.target;
          if (el.classList.contains('blackout-modal')) {
            onCloseModal()
          }
        }}
      >
        <div className="modal-create-campaign-from-rules"
        >
          <div className="modal-create-campaign-from-rules__header">
            <TitlePage
              title={`Добавление новой задачи`}
            />

            <ButtonClose
              onClick={(e) => {
                if (!isDisabledStart) {
                  setIsModalExit(true)
                } else {
                  onCloseModal()
                }
              }}
            />
          </div>

          <div className="modal-create-campaign-from-rules__main-content">
            <div className="modal-create-campaign-from-rules__left-content">
              <TitlePage
                medium
                title='Выбор категории'
              />

              <div className="modal-create-campaign-from-rules__select-group">
                <DropDownSelector
                  required={true}
                  state={selectedCategory2}
                  options_prop={categoryData2}
                  setState={(e) => setSelectedCategory2(e)}
                  fetchCallback={(e) => setCategoryPage2(e)}
                  setInputChange={(e) => setCategoryQuery2(e)}
                  placeholder="Категория"
                  onBlur={() => { }}
                  disabled={currentСampaign}
                />
              </div>

              <ButtonBasic
                green
                text="Сохранить"
                size='56px'
                onClick={(e) => {
                  if (currentСampaign) {
                    if (isSave) {
                      onCloseModal()
                    }
                  } else {
                    fetchСreateСampaign()
                  }
                }}
                style={{ marginTop: 'auto' }}
                disabled={isDisabled || currentСampaign}
              />
            </div>

            <div className="modal-create-campaign-from-rules__right-content">
              <div className='modal-create-campaign-from-rules__toolbar'>
                <StepPoints
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                  totalSteps={4}
                />

                <ButtonBasic
                  green
                  text="Следующий щаг"
                  onClick={(e) => {
                    setCurrentStep(currentStep + 1)
                  }}
                  disabled={isDisabled || currentStep == 4 || !isSave}
                />
              </div>


              {(currentStep === 1) && <StepItem
                title={<>Шаг 1: Выберите категорию и нажмите на кнопку “Сохранить”</>}
                description={
                  <>
                    <span style={{ color: 'red' }}>
                      {' '}
                      Красными звездочками
                    </span>{' '}
                    выделены обязательные пункты для заполнения</>}
              />}

              {(currentStep === 2) && (
                <>
                  <StepItem
                    title={`Шаг 2: Загрузите шаблон для заполнения`}
                  />

                  <div className="prepared_scenarios__content">
                    <div className='prepared_scenarios__btn-upload'>
                      <ButtonBasic
                        blue
                        text='Загрузить шаблон'
                        disabled={isDisabledTemplate}
                        loading={loadingUpload1}
                      />

                      <input
                        ref={fileInputRef1}
                        type="file"
                        id="fileInput"
                        onChange={(e) => {
                          if (selectedCategory2?.value) {
                            handleFile(e)
                          } else {
                            alert('Выберите категорию')
                          }
                        }}
                      />
                    </div>

                    {isLoadTemplate && <MoonLoader
                      color="#7b7b7b"
                      size={24}
                    />}

                    {fileTemplate?.url && <a
                      className='modal-create-campaign-from-rules__link'
                      href={fileTemplate?.url}
                      onClick={(e) => handleDownload(e, fileTemplate?.name, fileBarcode?.url)}
                    >{fileTemplate?.url}</a>}
                  </div>
                </>
              )}

              {(currentStep === 3) &&
                <div className="prepared_scenarios__content">
                  <StepItem
                    title='Шаг 3: Загрузите список баркодов'
                  />

                  <div className='prepared_scenarios__btn-upload'>
                    <ButtonBasic
                      text='Загрузить баркоды'
                      disabled={isDisabledBarcode}
                      loading={loadingUpload2}
                    />

                    <input
                      ref={fileInputRef2}
                      type="file"
                      id="fileInput"
                      onChange={(e) => {
                        if (selectedCategory2?.value) {
                          handleFileBarcode(e)
                        } else {
                          alert('Выберите категорию')
                        }
                      }}
                    />
                  </div>

                  {isLoadBarcode && <MoonLoader
                    color="#7b7b7b"
                    size={24}
                  />}

                  {fileBarcode?.url && <a
                    className='modal-create-campaign-from-rules__link'
                    href={fileBarcode?.url}
                    onClick={(e) => handleDownload(e, fileBarcode?.name, fileBarcode?.url)}
                  >{fileBarcode?.url}</a>}
                </div>

              }

              {(currentStep === 4) &&
                <div className="prepared_scenarios__content">
                  <StepItem
                    title='Шаг 4: Запустите задачу нажав на кнопку'
                  />

                  <ButtonBasic
                    green
                    text='Запустить'
                    onClick={(e) => fetchStartTask(e)}
                    disabled={isDisabledStart}
                  />
                </div>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { ModalCreateAutocompleteTemplatesAi };
